import { render, staticRenderFns } from "./themeSelector.vue?vue&type=template&id=3436cd4d&scoped=true"
import script from "./themeSelector.vue?vue&type=script&lang=js"
export * from "./themeSelector.vue?vue&type=script&lang=js"
import style0 from "./themeSelector.vue?vue&type=style&index=0&id=3436cd4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3436cd4d",
  null
  
)

export default component.exports